import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export type URL = {
  title: string;
  url: string;
};

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private titleChange = new Subject<string>();
  private breadcrumbChange = new Subject<URL[]>();

  public readonly titleChanged$: Observable<string>;
  public readonly breadcrumbChanged$: Observable<URL[]>;

  constructor() {
    this.titleChanged$ = this.titleChange.asObservable();
    this.breadcrumbChanged$ = this.breadcrumbChange.asObservable();
  }

  public changeTitle(title: string) {
    this.titleChange.next(title);
  }

  public changeBreadcrumb(breadcrumb: URL[]) {
    this.breadcrumbChange.next(breadcrumb);
  }
}
